/*Kelvin Roger Ang Yap 2017
	krayap@gmail.com
*/
//import on files
Vue.component('zoom', require('./components/zoom.vue').default);
